<template lang="pug">
    .settings(v-if='settings')
        div
            | {{ $i18n.t('trainer.trainer_gameFormSetting_view') }}:
            | {{ $i18n.tc(`trainer.trainer_gameFormSetting_${settings.viewType}`, 1) }}
        div
            | {{ $i18n.t('trainer.trainer_gameFormSetting_showTime') }}:
            | {{ settings.showTime + ' ' +$i18n.t('trainer.trainer_gameFormSettingValue_seconds')}}

        div
            | {{ $i18n.t('trainer.trainer_gameFormSetting_movement', {element: $i18n.t('trainer.trainer_gameFormSettingValue_' + settings.viewType)}) }}:
            | {{ settings.wordsMovement ? $i18n.t('progress.progress_preview_statusOn') : $i18n.t('progress.progress_preview_statusOf') }}

        div
            | {{ $i18n.t('progress.progress_preview_timeLimit') }}:
            | {{ settings.timeLimit + ' ' + $i18n.t('trainer.trainer_gameFormSettingValue_minutes') }}

        div
            | {{ $i18n.t('trainer.trainer_gameFormSetting_music') }}:
            | {{ settings.isMusicOn ? $i18n.t('progress.progress_preview_statusOn') : $i18n.t('progress.progress_preview_statusOf') }}

        div
            | {{ $i18n.t('trainer.trainer_gameFormSetting_distractingPictures') }}:
            | {{ settings.pictures ? $i18n.t('progress.progress_preview_statusOn') : $i18n.t('progress.progress_preview_statusOf') }}
        slot
</template>

<script>
    import TrainerUtilities from '../../../utils/trainer/trainer';
    import gamePreviewMixin from '../../../utils/trainer/gamePreviewMixin';

    export default {
        mixins: [TrainerUtilities, gamePreviewMixin],
        props: {
            game: Object,
            parameters: Object,
            userId: Number,
            parametersFrom: {
                type: String,
                default: 'homework',
            },
            withIcon: Boolean,
        },
    };
</script>
